import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from "@angular/core";
import { LorenGeofencingZone } from "../../interfaces/loren-geofencing-zone.interface";
import { LorenBreakpointObserverService } from "../../../../shared/services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import { LorenPrivilegeEntityType } from "../../../loren-roles/interfaces/loren-role.interface";

@Component({
  selector: "loren-map-zones-list",
  templateUrl: "./loren-map-zones-list.component.html",
  styleUrls: ["./loren-map-zones-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LorenMapZonesListComponent {
  private lorenBreakpointObserverService = inject(LorenBreakpointObserverService);

  constructor() {
    this.lorenBreakpointObserverService
      .getHandsetStateSubscription()
      .subscribe((x) => {
        this.isHandset = x;
      });
  }

  @Input() zones: LorenGeofencingZone[];
  @Output() zoneClick = new EventEmitter<number>();
  @Output() zoneDeleteClick = new EventEmitter<number>();
  @Output() zoneEditClick = new EventEmitter<LorenGeofencingZone>();

  isHandset: boolean;
  privileges = LorenPrivilegeEntityType;
}
